import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../components/AnimatedSection';
import './InfoSection.scss';

const InfoSection = () => {
    const { t } = useTranslation();
    const prefersReducedMotion = useReducedMotion();

    const fadeUp = (delay, duration = 1.0) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    const cardReveal = (delay) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20, scale: 0.98 },
                  whileInView: { opacity: 1, y: 0, scale: 1 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration: 1.0, delay, ease: EASE_OUT_EXPO },
              };

    const slideRight = prefersReducedMotion
        ? {}
        : {
              initial: { opacity: 0, x: 20 },
              whileInView: { opacity: 1, x: 0 },
              viewport: { once: true, amount: 0.25 },
              transition: { duration: 1.1, delay: 0.4, ease: EASE_OUT_EXPO },
          };

    const cards = [
        {
            id: 'gospel',
            title: t('gospel'),
            text: t('gospel_text'),
            href: 'https://usaregeneration.churchcenter.com/home'
        },
        {
            id: 'groups',
            title: t('life_groups'),
            text: t('life_groups_text'),
            href: 'https://usaregeneration.churchcenter.com/groups'
        },
        {
            id: 'events',
            title: t('upcoming_events_card'),
            text: t('upcoming_events_text'),
            href: 'https://usaregeneration.churchcenter.com/calendar?view=gallery'
        }
    ];

    return (
        <section className="info-section">
            <div className="info-section__container">
                <div className="info-section__top">
                    <motion.span className="info-section__label" {...fadeUp(0)}>
                        {t('searching_purpose')}
                    </motion.span>
                    <motion.p className="info-section__description" {...fadeUp(0.2)}>
                        {t('searching_description')}
                    </motion.p>
                    <motion.p className="info-section__highlight" {...fadeUp(0.2)}>
                        {t('walk_alone')}
                    </motion.p>
                </div>

                <div className="info-section__cards">
                    {cards.map((card, index) => (
                        <motion.a
                            key={card.id}
                            href={card.href}
                            className="info-section__card"
                            target="_blank"
                            rel="noopener noreferrer"
                            {...cardReveal(0.3 + index * 0.15)}
                        >
                            <h3 className="info-section__card-title">{card.title}</h3>
                            <p className="info-section__card-text">{card.text}</p>
                        </motion.a>
                    ))}
                </div>

                <motion.div className="info-section__sidebar" {...slideRight}>
                    <div className="info-section__sidebar-block">
                        <h3 className="info-section__sidebar-heading">{t('address')}</h3>
                        <p className="info-section__sidebar-text">
                            920 Trenton Rd, Fairless Hills PA 19030
                        </p>
                    </div>
                    <div className="info-section__sidebar-block">
                        <h3 className="info-section__sidebar-heading">{t('service_times')}</h3>
                        <p className="info-section__sidebar-text">{t('sunday')}</p>
                        <p className="info-section__sidebar-text">{t('service_english')}</p>
                        <p className="info-section__sidebar-text">{t('service_ukrainian')}</p>
                        <p className="info-section__sidebar-text">{t('service_evening')}</p>
                    </div>
                    <Link to="/join" className="button button--primary">
                        {t('find_out_more')}
                    </Link>
                </motion.div>
            </div>
        </section>
    );
};

export default InfoSection;
